import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useGetApiRequests, triggerNotification } from "../../../../../../common/CommonExport";

interface DeletePerformanceNoteModalProps {
  open: boolean;
  onClose: () => void;
  employeeId: string;
  noteId: string;
  refreshData: () => void;
}

export default function DeletePerformanceNoteModal({
  open,
  onClose,
  employeeId,
  noteId,
  refreshData,
}: DeletePerformanceNoteModalProps) {
  const deleteApi = useGetApiRequests("employeePerformanceNoteDelete", "DELETE");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const handleDelete = async () => {
    setDeleteLoader(true);

    setTimeout(async () => {
      try {
        const deleteResponse: any = await deleteApi(
          null,
          { employeePerformanceNotesId: noteId },
          { employeeId }
        );


        if (deleteResponse?.data?.status?.success === "Success") {
          refreshData();
          triggerNotification(
            "success",
            "Note deleted successfully.",
            "",
            "topRight",
            3
          );
        } else {
          triggerNotification(
            "error",
            "",
            deleteResponse?.status?.data?.message || "Failed to delete performance note.",
            "topRight"
            , 3
          );
        }
      } catch (err) {
        console.error("Error deleting note", err);
        triggerNotification(
          "error",
          "",
          "An error occurred while deleting the note",
          "topRight",
          3
        );
      } finally {
        setDeleteLoader(false);
        onClose();
      }
    }, 3000);
  };

  return (
    <Modal
      className="close-confirmation-popup w-[545px]"
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      maskClosable={false}
    >
      <div className="mt-6">
        <p className="font-medium">Are you sure you want to delete this note?</p>
        <div className="flex justify-end mt-8 space-x-3">
          <Button
            onClick={onClose}
            disabled={deleteLoader}
            className="addButton secondary"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleDelete}
            loading={deleteLoader}
            className="addButton"
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
